import {SocketApi} from "proto_socket_typescript";
import {makeAutoObservable} from "mobx";
import {proto} from "../proto/messages";
import {calendar} from "../proto/compiled";

export class TerminiStore {
    api: SocketApi;
    tecajTip: string;
    tecaj: string;
    limit: number;
    lectures: calendar.IAvailableLecture[] = [];
    loading = true;
    private subscription: any;

    constructor(api: SocketApi, tecajTip: string, tecaj: string, limit: number = 9) {
        this.api = api;
        this.tecajTip = tecajTip;
        this.tecaj = tecaj;
        this.limit = limit;

        this.subscription = api.getMessageHandler(new proto.RxAvailableLectures())
            .subscribe((m) => this.onAvailableLectures(m));

        makeAutoObservable(this);

        api.connection.whenConnected.then(() => this.load());
    }

    private load() {
        this.loading = true;
        this.api.sendMessage(proto.TxLoadAvailableLectures.create({
            tecajTip: this.tecajTip,
            tecaj: this.tecaj,
            limit: this.limit,
        }));
    }

    private onAvailableLectures(message: proto.RxAvailableLectures) {
        this.lectures = message.proto.lectures ?? [];
        this.loading = false;
    }

    dispose() {
        this.subscription?.unsubscribe();
    }
}
